module.exports = __webpack_public_path__ + "assets/img/search-not-found.7465eb3c.png";